import React from 'react'

import { useTranslation } from 'react-i18next'
import { connect, DataItem } from 'scrivito'

import { PhoneCallLogDrawer } from './PhoneCallLogDrawer'
import { Button } from '@/Atomic/Molecules/Button'
import { useModalHandler } from '@/hooks/useModalHandler'

interface LogPhoneCallButtonProps {
  dataItem: DataItem
  size?: 'sm' | 'md' | 'lg'
  buttonClassName?: string
}

export const LogPhoneCallButton: React.FC<LogPhoneCallButtonProps> = connect(
  ({ dataItem, size = 'sm', buttonClassName }) => {
    const { t } = useTranslation()
    const { isOpen, openModal, closeModal } = useModalHandler()

    return (
      <>
        <Button
          variant="outlined"
          size={size}
          onClick={openModal}
          buttonClassName={buttonClassName}
        >
          {t('components.activity.phoneCall.button')}
        </Button>
        <PhoneCallLogDrawer
          contextItem={dataItem}
          isOpen={isOpen}
          close={closeModal}
        />
      </>
    )
  },
)
